export const camelCaseToNormal = str => {
  const result = str.replace(/([A-Z])/g, ' $1')
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1)
  return finalResult
}

export const emailValidator = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const reduceString = (str, maxLength = 21) => {
  if (str.length > maxLength) {
    const midIndex = (maxLength - 3) / 2
    return str.substring(0, midIndex) + '...' + str.substring(str.length - midIndex, str.length)
  } else {
    return str
  }
}
